import { Component, OnInit } from '@angular/core';
import { NgbModalConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SharedService } from '../../services/shared.service';
import { QuickWidgetFormModalComponent } from '../quick-widget-form-modal/quick-widget-form-modal.component';

@Component({
  selector: 'app-new-app-widget',
  templateUrl: './new-app-widget.component.html',
  styleUrls: ['./new-app-widget.component.scss']
})
export class NewAppWidgetComponent implements OnInit {
  activeTab: string = 'widgets';
  widgetList = [];
  isLoading = false;

  // Drag and drop
  dragIndex: number = null;
  dragOverIndex: number = null;

  // Share widgets
  shareWidgetList = [];
  usersList = [];
  selectedUsers = [];
  dropdownSettings = {};
  groupList = [];
  groupedWidgetTitle = '';
  groupedWidgetId = '';
  groupedWidgets = [];
  groupedWidgetValidation = false;
  groupedWidgetValidationMsg = false;
  showGroupAddForm = false;
  isGroupEditcase = false;

  constructor(
    config: NgbModalConfig,
    private modalService: NgbModal,
    private sharedService: SharedService,
  ) {
    config.backdrop = 'static';
    config.keyboard = false;
  }

  ngOnInit() {
    this.getWidgets();
    this.getUsersList();
    this.getGroupWidgets();

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'user_id',
      textField: 'user_full_name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: true
    };
  }

  switchTab(tab: string) {
    this.activeTab = tab;
    if (tab === 'share') {
      this.getShareWidgets();
    }
  }

  // === WIDGETS TAB ===
  getWidgets() {
    this.widgetList = [];
    this.isLoading = true;
    this.sharedService.getWidgets().subscribe(
      data => {
        for (let wid of data) {
          this.sharedService.getWidgetDatas(wid).subscribe(
            widData => {
              this.isLoading = false;
              if (widData) {
                this.widgetList.push({
                  id: wid.widget_id,
                  title: widData.title,
                  result_data: widData.data,
                  symbol: widData.data_type_symbol,
                  goal: widData.goal,
                  is_multiple: widData.is_multiple,
                  is_null_result: widData.is_null_result,
                  exceed_goal: widData.exceed_goal,
                  percentage_value: widData.percentage_value,
                  datapercentage_val: widData.datapercentage_val,
                  shouldbepercentage_val: widData.shouldbepercentage_val,
                  shouldbe_color: widData.shouldbe_color,
                  displayStartDate: widData.displayStartDate,
                  displayEndDate: widData.displayEndDate,
                  diffrence: widData.diffrence,
                  target: widData.target,
                  shouldbe: widData.shouldbe,
                  created: wid.created,
                  order_id: wid.order_id
                });
                this.widgetList.sort((a, b) => a.order_id - b.order_id);
              }
            }
          );
        }
      }
    );
  }

  openFormModal(id) {
    const modalRef = this.modalService.open(QuickWidgetFormModalComponent);
    modalRef.componentInstance.widget_id = id;
    modalRef.result.then(() => {
      this.getWidgets();
    }).catch(() => {});
  }

  discardWidget(id) {
    this.sharedService.removeWidget(id).subscribe(() => {
      this.getWidgets();
    });
  }

  // === DRAG AND DROP ===
  onDragStart(index: number) {
    this.dragIndex = index;
  }

  onDragOver(event: DragEvent, index: number) {
    event.preventDefault();
    this.dragOverIndex = index;
  }

  onDragLeave() {
    this.dragOverIndex = null;
  }

  onDrop(event: DragEvent, dropIndex: number) {
    event.preventDefault();
    if (this.dragIndex === null || this.dragIndex === dropIndex) {
      this.dragIndex = null;
      this.dragOverIndex = null;
      return;
    }

    const draggedItem = this.widgetList[this.dragIndex];
    this.widgetList.splice(this.dragIndex, 1);
    this.widgetList.splice(dropIndex, 0, draggedItem);

    // Build reorder payload matching the format the API expects
    const reorderData = this.widgetList.map((wid, i) => ({
      widget_id: wid.id,
      title: wid.title,
      order_id: i
    }));

    this.sharedService.reOrderWidgets(reorderData).subscribe();

    this.dragIndex = null;
    this.dragOverIndex = null;
  }

  onDragEnd() {
    this.dragIndex = null;
    this.dragOverIndex = null;
  }

  // === SHARE TAB ===
  getShareWidgets() {
    this.shareWidgetList = [];
    this.sharedService.getWidgets().subscribe(
      data => {
        this.shareWidgetList = data;
      }
    );
  }

  getUsersList() {
    this.sharedService.getUsersList().subscribe(
      data => {
        this.usersList = data;
      }
    );
  }

  getGroupWidgets() {
    this.sharedService.getGroupedWidget().subscribe(
      data => {
        this.groupList = data;
      }
    );
  }

  createNew() {
    this.clearGroupedWidgetFields();
    this.showGroupAddForm = true;
  }

  checkGroupWidget(event, widgetId) {
    if (event.target.checked) {
      if (!this.isGroupEditcase) {
        this.showGroupAddForm = true;
      }
      this.groupedWidgets.push(widgetId);
    } else {
      for (let i = 0; i < this.groupedWidgets.length; i++) {
        if (this.groupedWidgets[i] === widgetId) {
          this.groupedWidgets.splice(i, 1);
        }
      }
    }
  }

  clearGroupedWidgetFields() {
    this.selectedUsers = [];
    this.groupedWidgets = [];
    this.groupedWidgetId = '';
    this.groupedWidgetTitle = '';
    this.isGroupEditcase = false;
    this.showGroupAddForm = false;
  }

  saveGroupedWidgets() {
    this.groupedWidgetValidation = false;
    if (!this.groupedWidgetTitle) {
      this.groupedWidgetValidation = true;
    }
    if (this.selectedUsers.length == 0) {
      this.groupedWidgetValidation = true;
    }
    if (this.groupedWidgets.length == 0) {
      this.groupedWidgetValidation = true;
    }
    if (this.groupedWidgetValidation) {
      this.groupedWidgetValidationMsg = true;
      return false;
    } else {
      this.groupedWidgetValidationMsg = false;
    }

    if (!this.isGroupEditcase) {
      this.groupedWidgetId = '';
    }

    var groupWidgetParam = {
      'groupId': this.groupedWidgetId,
      'groupTitle': this.groupedWidgetTitle,
      'groupUsers': this.selectedUsers,
      'groupedWidgets': this.groupedWidgets
    };

    this.sharedService.postGroupedWidget(groupWidgetParam).subscribe(
      data => {
        this.clearGroupedWidgetFields();
        this.getGroupWidgets();
      }
    );
  }

  editWidgetGroup(groupId) {
    this.isGroupEditcase = true;
    this.selectedUsers = [];
    this.groupedWidgets = [];
    this.groupedWidgetId = '';
    this.groupedWidgetTitle = '';
    this.showGroupAddForm = false;
    this.sharedService.getSingleGroupData(groupId).subscribe(
      data => {
        this.groupedWidgetId = data.id;
        this.groupedWidgetTitle = data.group_title;
        if (data.group_users) {
          for (let i = 0; i < data.group_users.length; i++) {
            this.selectedUsers.push({
              user_full_name: data.group_users[i].user.user_first_name + ' ' + data.group_users[i].user.user_last_name,
              user_id: data.group_users[i].widget_user_id
            });
          }
        }
        if (data.widget_list) {
          for (let i = 0; i < data.widget_list.length; i++) {
            this.groupedWidgets.push(data.widget_list[i].widget_id);
          }
        }
        this.showGroupAddForm = true;
      }
    );
  }

  removeWidgetGroup(id) {
    var groupWidgetParam = { 'id': id };
    this.sharedService.postDeleteGroupWidget(groupWidgetParam).subscribe(
      data => {
        this.getGroupWidgets();
      }
    );
  }

  onSelectAll(items: any) {}
}
